export const importImages = (r) => {
    let images = {};
    r.keys().forEach((item) => {
      // Clean up the file name by removing the leading "./"
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };
  